import { Account } from "gen/coa/models_pb"
import { Chip, ChipProps } from "shared-web/components/base/informational/Chip"
interface AccountNumberChipProps extends Omit<ChipProps, "text" | "color"> {
  account: Account
}

export function AccountNumberChip({
  account,
  ...chipProps
}: AccountNumberChipProps) {
  return <Chip color="gray" text={account.number.toString()} {...chipProps} />
}
